import React from 'react';

const InputChecked = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3441 18.8403C9.99375 18.8403 9.6434 18.7235 9.40983 18.3731L4.03773 13.001C3.45381 12.4171 3.45381 11.5996 4.03773 11.0157C4.62166 10.4318 5.43915 10.4318 6.02307 11.0157L10.3441 15.3367L18.0519 7.62894C18.6358 7.04501 19.4533 7.04501 20.0372 7.62894C20.6212 8.21286 20.6212 9.03035 20.0372 9.61428L11.3952 18.2563C11.0448 18.7235 10.6945 18.8403 10.3441 18.8403Z"
        fill="#02B2FF"
      />
    </svg>
  );
};

export default InputChecked;
